import { render, staticRenderFns } from "./accountNew.vue?vue&type=template&id=9fd09e50&scoped=true"
import script from "./accountNew.vue?vue&type=script&lang=js"
export * from "./accountNew.vue?vue&type=script&lang=js"
import style0 from "./accountNew.vue?vue&type=style&index=0&id=9fd09e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd09e50",
  null
  
)

export default component.exports